import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { environment } from '../environments/environment';
import { Router } from '@angular/router';
import { ActivatedRouteSnapshot } from '@angular/router';
import { Observable, throwError, Subject, forkJoin, BehaviorSubject } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class ApiService {
	constructor(private httpClient: HttpClient, private router: Router) { }

	private API_URL = environment.API_URL;

	getDefaultDateRange(returnString: boolean) {
		let today = new Date();
		let yesterday = new Date();
		yesterday.setDate(yesterday.getDate() - 1);
		return {
			start_date: returnString ? this.getDateStringFromDate(yesterday) : yesterday,
			end_date: returnString ? this.getDateStringFromDate(today) : today
		}
	}

	getDefaultDateRange3Months(returnString: boolean) {
		let today = new Date();
		let fromDate = new Date();
		fromDate.setDate(fromDate.getDate() - 90);
		return {
			start_date: returnString ? this.getDateStringFromDate(fromDate) : fromDate,
			end_date: returnString ? this.getDateStringFromDate(today) : today
		}
	}

	getDateStringFromDate(date: any) {
		if (date == "" || date == null || date == undefined) {
			return null;
		}
		var month = date.getMonth() + 1;
		var day = date.getDate();
		var year = date.getFullYear();
		var dayStr = day < 10 ? '0' + day : day;
		var monthStr = month < 10 ? '0' + month : month;
		var fromStr = year + "-" + monthStr + "-" + dayStr;
		return fromStr;
	}

	getDateFromDateString(date: any) {
		if (date == "" || date == null || date == undefined) {
			return null;
		}
		try {
			date = date.split("T")[0];
			var dateArr = date.split("-");
			date = new Date(dateArr.join("/"));
		} catch (error) {
			date = null;
		}
		return date;
	}

	getDateFromDateStringDDMMYYYY(date: any) {
		if (date == "" || date == null || date == undefined) {
			return null;
		}
		try {
			date = date.split("T")[0];
			var dateArr = date.split("-").reverse();
			date = new Date(dateArr.join("/"));
		} catch (error) {
			date = null;
		}
		return date;
	}

	getDateStringFromDateDDMMYYYY(date: any) {
		if (date == "" || date == null || date == undefined) {
			return "";
		}
		var month = date.getMonth() + 1;
		var day = date.getDate();
		var year = date.getFullYear();
		var dayStr = day < 10 ? '0' + day : day;
		var monthStr = month < 10 ? '0' + month : month;
		var fromStr = dayStr + "-" + monthStr + "-" + year;
		return fromStr;
	}

	public getHomeURL() {
		return "/app/appointmentList";
	}

	navigateToLogin(storeState: boolean) {
		localStorage.clear();
		if (storeState) {
			this.router.navigate(['/login'], { queryParams: { returnUrl: this.router.routerState.snapshot.url } });
		} else {
			this.router.navigate(['/login']);
		}
	}

	public loginAPI(user: any) {
		return this.httpClient.post(this.API_URL + "login", user);
	}

	public logout() {
		return this.httpClient.get(this.API_URL + "logout");
	}

	public generate_qr(data: any) {
		return this.httpClient.post(this.API_URL + "generate_qr", data, { responseType: "blob" });
	}

	public verifyGoogleAuthOTP(params: any) {
		const httpParams: HttpParamsOptions = { fromObject: params } as HttpParamsOptions;
		const options = { params: new HttpParams(httpParams) };
		return this.httpClient.get(this.API_URL + "verify_otp", options);
	}

	public resetPassword(data: any) {
		return this.httpClient.post(this.API_URL + "changePassword/", data);
	}

	public getAppointmentDetails(params: any) {
		const httpParams: HttpParamsOptions = { fromObject: params } as HttpParamsOptions;
		const options = { params: new HttpParams(httpParams) };
		return this.httpClient.get(this.API_URL + "get_appointment", options);
	}

	public getVesselListByCompany(params: any) {
		const httpParams: HttpParamsOptions = { fromObject: params } as HttpParamsOptions;
		const options = { params: new HttpParams(httpParams) };
		return this.httpClient.get(this.API_URL + "listVesselByCompany", options);
	}

	public getBranchListByCompany(params: any) {
		const httpParams: HttpParamsOptions = { fromObject: params } as HttpParamsOptions;
		const options = { params: new HttpParams(httpParams) };
		return this.httpClient.get(this.API_URL + "listbranchByCompany", options);
	}

	public getApptDetails(ref_no: any) {
		return this.httpClient.get(this.API_URL + "getappt/" + ref_no);
	}

	public getAllCompanyList() {
		return this.httpClient.get(this.API_URL + "list_company");
	}

	public getAllRankList() {
		return this.httpClient.get(this.API_URL + "list_ranks");
	}

	public getAllProfileList() {
		return this.httpClient.get(this.API_URL + "listprofile");
	}

	public createUpdateAppointment(data: any, action: string) {
		if (action == "create") {
			return this.httpClient.post(this.API_URL + "registerappt", data);
		} else {
			return this.httpClient.put(this.API_URL + "updateAppt", data);
		}
	}

	public deleteAppt(id: any) {
		const httpParams: HttpParamsOptions = { fromObject: { id: id } } as HttpParamsOptions;
		const options = { params: new HttpParams(httpParams) };
		return this.httpClient.delete(this.API_URL + "deleteappt", options);
	}

	public deleteProfile(id: any) {
		return this.httpClient.delete(this.API_URL + "delete_profile/" + id);
	}

	public createUpdateProfile(data: any, action: string) {
		if (action == "create") {
			return this.httpClient.post(this.API_URL + "register_profile", data);
		} else {
			return this.httpClient.put(this.API_URL + "register_profile", data);
		}
	}

	public getProfileDetails(id: any) {
		return this.httpClient.get(this.API_URL + "EditProfileData/" + id);
	}

	public restoreProfile(id: any) {
		return this.httpClient.post(this.API_URL + "restore_profile_api/" + id, {});
	}

	public deleteBranch(id: any) {
		return this.httpClient.delete(this.API_URL + "delete_branch/" + id);
	}

	public createUpdateBranch(data: any, action: string) {
		if (action == "create") {
			return this.httpClient.post(this.API_URL + "register_branch", data);
		} else {
			return this.httpClient.put(this.API_URL + "register_branch", data);
		}
	}

	public getBranchDetails(id: any) {
		return this.httpClient.get(this.API_URL + "register_branch/" + id);
	}

	public restoreBranch(id: any) {
		return this.httpClient.post(this.API_URL + "restore_branch/" + id, {});
	}

	public createUpdateInvoice(data: any) {
		if (data.id) {
			return this.httpClient.put(this.API_URL + "InvoiceApi", data);
		} else {
			return this.httpClient.post(this.API_URL + "InvoiceApi", data);
		}
	}

	public getInvoiceDetails(id: any) {
		return this.httpClient.get(this.API_URL + "InvoiceApi/" + id);
	}

	public get_invoice_number() {
		return this.httpClient.get(this.API_URL + "get_invoice_number");
	}

	public getCurrency(params: any) {
		const httpParams: HttpParamsOptions = { fromObject: params } as HttpParamsOptions;
		const options = { params: new HttpParams(httpParams) };
		return this.httpClient.get(this.API_URL + "CurrencyApi", options);
	}

	public paid_unpaid(data: any) {
		return this.httpClient.post(this.API_URL + "paid_unpaid", data);
	}

	public doneNotDone(data: any) {
		return this.httpClient.post(this.API_URL + "doneNotDone", data);
	}

	public getBillPdf(data: any) {
		return this.httpClient.post(this.API_URL + "invoice", data, { observe: 'response', responseType: 'arraybuffer' });
	}

	public deleteBill(id: any) {
		const httpParams: HttpParamsOptions = { fromObject: { id: id } } as HttpParamsOptions;
		const options = { params: new HttpParams(httpParams) };
		return this.httpClient.delete(this.API_URL + "InvoiceApi", options);
	}

	public createCertificate(id: any) {
		const httpParams: HttpParamsOptions = { fromObject: { id: id } } as HttpParamsOptions;
		return this.httpClient.get(this.API_URL + "createCertificate", { params: new HttpParams(httpParams), observe: 'response', responseType: 'arraybuffer' });
	}

	public createCertificateMultiple(dataList: any[]): Observable<unknown> {
		let responses: any = [];
		dataList.forEach((data) => {
			const httpParams: HttpParamsOptions = { fromObject: { id: data["id1"] } } as HttpParamsOptions;
			let response = this.httpClient.get(this.API_URL + "createCertificate", { params: new HttpParams(httpParams), observe: 'response', responseType: 'arraybuffer' });
			responses.push(response);
		})
		return forkJoin(responses);
	}

	public attendappt(data: any) {
		return this.httpClient.post(this.API_URL + "attendappt", data);
	}

	public saveMultipleCertificate(data: any) {
		return this.httpClient.post(this.API_URL + "saveMultipleCertificate", data, { observe: 'response', responseType: 'arraybuffer' });
	}

	public appoinmentListExcel(data: any) {
		return this.httpClient.post(this.API_URL + "AppoinmentListExcel", data, { observe: 'response', responseType: 'arraybuffer' });
	}

	public deleteCase(ref_no: any) {
		const httpParams: HttpParamsOptions = { fromObject: { ref_no: ref_no } } as HttpParamsOptions;
		return this.httpClient.delete(this.API_URL + "delete_appt", { params: new HttpParams(httpParams) });
	}

	public getCertificateZip(url: any) {
		return this.httpClient.get(url, { observe: 'response', responseType: 'arraybuffer' });
	}

	public getAllScaleList() {
		return this.httpClient.get(this.API_URL + "listscales");
	}

	public deleteScale(id: any) {
		return this.httpClient.delete(this.API_URL + "delete_scales/" + id);
	}

	public createUpdateScale(data: any, action: string) {
		if (action == "create") {
			return this.httpClient.post(this.API_URL + "register_scales", data);
		} else {
			return this.httpClient.put(this.API_URL + "update_scales", data);
		}
	}

	public getScaleDetails(id: any) {
		const httpParams: HttpParamsOptions = { fromObject: { id: id } } as HttpParamsOptions;
		return this.httpClient.get(this.API_URL + "getscaledetails", { params: new HttpParams(httpParams) });
	}

	public restoreScale(id: any) {
		return this.httpClient.get(this.API_URL + "restore_scale_api/" + id);
	}

	public getAllCategoryList() {
		return this.httpClient.get(this.API_URL + "categorylist");
	}

	public deleteCategory(id: any) {
		return this.httpClient.delete(this.API_URL + "delete_category/" + id);
	}

	public createUpdateCategory(data: any, action: string) {
		if (action == "create") {
			return this.httpClient.post(this.API_URL + "register_category", data);
		} else {
			return this.httpClient.put(this.API_URL + "register_category", data);
		}
	}

	public getCategoryDetails(id: any) {
		const httpParams: HttpParamsOptions = { fromObject: { id: id } } as HttpParamsOptions;
		return this.httpClient.get(this.API_URL + "getcategorydetails", { params: new HttpParams(httpParams) });
	}

	public restoreCategory(id: any) {
		return this.httpClient.get(this.API_URL + "restore_category_api/" + id);
	}

	public deleteQuestion(id: any) {
		return this.httpClient.delete(this.API_URL + "delete_question/" + id);
	}

	public getQuestionDetails(id: any) {
		return this.httpClient.get(this.API_URL + "getQuestionById/" + id);
	}

	public getAllQuestions() {
		return this.httpClient.get(this.API_URL + "listquestion");
	}

	public createUpdateQuestion(data: any) {
		if (data.id) {
			return this.httpClient.put(this.API_URL + "register_question", data);
		} else {
			return this.httpClient.post(this.API_URL + "register_question", data);
		}
	}

	public getQuestionsFromProfileAndAnswers(id: any, apptIds: any[]): Observable<unknown> {
		let responses: any = [];
		apptIds.forEach((data) => {
			const httpParams: HttpParamsOptions = { fromObject: { id: data } } as HttpParamsOptions;
			let response = this.httpClient.get(this.API_URL + "list_que_ans", { params: new HttpParams(httpParams) });
			responses.push(response);
		});
		const httpParams: HttpParamsOptions = { fromObject: { profile: id } } as HttpParamsOptions;
		responses.push(this.httpClient.get(this.API_URL + "getQuestionsFromProfile", { params: new HttpParams(httpParams) }));
		return forkJoin(responses);
	}

	public saveScore(apptIds: any[]): Observable<unknown> {
		let responses: any = [];
		apptIds.forEach((data) => {
			const httpParams: HttpParamsOptions = { fromObject: { id: data } } as HttpParamsOptions;
			let response = this.httpClient.get(this.API_URL + "save_score", { params: new HttpParams(httpParams) });
			responses.push(response);
		});
		return forkJoin(responses);
	}

	public getNotes(apptIds: any[]): Observable<unknown> {
		let responses: any = [];
		apptIds.forEach((id) => {
			const data = {
				id: id,
				flag: "get",
				notes: ""
			}
			let response = this.httpClient.post(this.API_URL + "savenotes", data);
			responses.push(response);
		});
		return forkJoin(responses);
	}

	public get_save_SingleNotes(data: any) {
		return this.httpClient.post(this.API_URL + "savenotes", data);
	}

	public getScorelist(id: any) {
		const httpParams: HttpParamsOptions = { fromObject: { id: id } } as HttpParamsOptions;
		return this.httpClient.get(this.API_URL + "getScorelist", { params: new HttpParams(httpParams) });
	}

	public saveSingleAns(data: any) {
		return this.httpClient.post(this.API_URL + "save_que", data);
	}

	public saveAllAns(data: any) {
		return this.httpClient.post(this.API_URL + "save_all_questions", data);
	}

	public listTrainers() {
		return this.httpClient.get(this.API_URL + "list_user");
	}
}

export interface HttpParamsOptions {
	fromString?: string;
	fromObject?: {
		[param: string]: string | string[];
	};
	encoder?: HttpParameterCodec;
}

interface HttpParameterCodec {
	encodeKey(key: string): string
	encodeValue(value: string): string
	decodeKey(key: string): string
	decodeValue(value: string): string
}
